import { Component, Vue } from 'vue-property-decorator';

import { PLAN_LIMITS_LOGIC } from '@/services/constants/planLimits';
import { reportTypeFromRoute } from '@/services/utils/reportType';
import {mixins} from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';

@Component
export default class ColumnsSettingsDialogMixin extends mixins<UrlMixin>(UrlMixin) {
  getPlanLimits(item){
    switch(item.value) {
      case 'reports-clickssuspicious':
      case 'reports-visitssuspicious':
      case 'reports-impressionssuspicious':
        return {
          logic:PLAN_LIMITS_LOGIC.AT_LEAST_ONE_REQUIRED,
          addons:['ivtIpIsDatacenter', 'ivtIpIsBlacklisted','ivtFastClicker','ivtIpWithFrequentCampaignEvents', 'ivtIpWithFrequentEvents']
        };
      case 'reports-impressionssuspiciousdatacenterips':
      case 'reports-visitssuspiciousdatacenterips':
      case 'reports-clickssuspiciousdatacenterips':
      case 'reports-datacenterip':
        return 'ivtIpIsDatacenter';
      case 'reports-visitssuspiciousblacklistedips':
      case 'reports-clickssuspiciousblacklistedips':
      case 'reports-impressionssuspiciousblacklistedips':
      case 'reports-blacklistedip':
        return 'ivtIpIsBlacklisted';
      case 'reports-impressions_suspicious_ip_with_frequent_events':
      case 'reports-visits_suspicious_ip_with_frequent_events':
      case 'reports-clicks_suspicious_ip_with_frequent_events':
        return 'ivtIpWithFrequentEvents';
      case 'reports-impressions_suspicious_ip_with_frequent_campaign_events':
      case 'reports-visits_suspicious_ip_with_frequent_campaign_events':
        return 'ivtIpWithFrequentCampaignEvents';
      case 'reports-clicks_fast_clicker':
        return 'ivtFastClicker';
      case 'reports-clicks_suspicious_ip_with_frequent_campaign_events':
        return 'ivtIpWithFrequentCampaignEvents';
      case 'live_clicks-fast_clicker':
        return 'ivtFastClicker';
      case 'live_visits-ip_with_frequent_events':
      case 'live_clicks-ip_with_frequent_events':
        return 'ivtIpWithFrequentEvents';
      case 'live_visits-ip_with_frequent_campaign_events':
      case 'live_clicks-ip_with_frequent_campaign_events':
        return 'ivtIpWithFrequentCampaignEvents';
    }
  }

  isSpecialDimensions(dimension:string=reportTypeFromRoute()) {
    return ['errors','postbacks','conversions', 'live-clicks', 'live-visits'].includes(dimension)
  }

  isMetricAllowToInherit(inheritColumns: boolean, dimension:string, type:string) {
    // pages e.x. errors, postbacks

    if(this.isSpecialDimensions(dimension)) {
      if (dimension === type) {
        return true
      }

      if (dimension === 'live-clicks') {
        return false
      }

      if (dimension === 'live-visits') {
        return false
      }

      return false
    }

    // pages e.x. NOT errors, postbacks
    return !this.isSpecialDimensions(type)
      && !this.isSpecialDimensions(dimension)
      && (inheritColumns || dimension === type);

    
  }

  get allowToSaveThisMetricOnServer() {
    const type = reportTypeFromRoute();
    const list = ['ips','subnet-small','subnet-big','useragents','referrers','referrer-domains','month','day','day-of-week','hour-of-day','live-clicks','live-visits','custom1','custom2','custom3','custom4','custom5','custom6','custom7','custom8','custom9','custom10'];
    return list.includes(type) && this.isReport() || !this.isReport()
  }

  groupingTranslation(group){
    switch(group.id) {
      case 'general':
        return this.t('____x.general');
      case 'integration_details':
        return this.t('Integration Details');
      case 'total_events_data':
        return this.t('Total Events Data');
      case 'basic_financial_data':
        return this.t('Basic Financial Data');
      case 'key_performance_data':
        return this.t('Key Performance Data');
      case 'advanced_data_on_events':
        return this.t('Advanced Data on Events');
      case 'ivt':
        return this.t('Invalid Traffic Details');
      case 'advanced_conversions_data':
        return this.t('Advanced Conversions Data');
      case 'custom_columns':
        return this.t('Custom Columns');
      case 'postback_related_data':
        return this.t('Postback-related Data');
      case 'elements_related_data':
        return this.t('Elements-related Data');
      case 'categories_related_data':
        return this.t('Categories-related Data');
      case 'traffic_source_related_data':
        return this.t('Traffic Source-related Data');
      default:
        return group.name || group.id;
    }
  }

  groupingTooltipTranslation(group){
    switch(group.id) {
      case 'general':
        return this.t('General data about the element or category of report');
      case 'integration_details':
        return this.t('Data on the campaign integrated via API');
      case 'total_events_data':
        return this.t('Sum of data on each event type for the selected report period');
      case 'basic_financial_data':
        return this.t('Sum of cost, revenue and profit for the selected report period');
      case 'key_performance_data':
        return this.t('Metrics indicating the performance of the campaign, campaign element, or category for the selected report period');
      case 'advanced_data_on_events':
        return this.t('More detailed data on each type of tracked event for the selected report period');
      case 'ivt':
        return this.t('Data on invalid and suspicious traffic for the selected report period');
      case 'advanced_conversions_data':
        return this.t('More detailed data on the status and revenue of tracked conversions for the selected report period');
      case 'custom_columns':
        return this.t('Custom conversions and columns based on the user-defined formulas');
      case 'postback_related_data':
        return this.t('Data on postback of affiliate network or traffic source depending on the selected report');
      case 'elements_related_data':
        return this.t('Data on elements related to conversion or visit/click depending on the selected report');
      case 'categories_related_data':
        return this.t('Additional data on conversion or visit/click depending on the selected report');
      case 'traffic_source_related_data':
        return this.t('Data received from a traffic source which is associated with a conversion or visit/click depending on the report selected');
      default:
        return null;
    }
  } 
}